module.exports = __webpack_public_path__ + "static/media/achievement-see-10-do-10-share-10.7918995e.svg";